/**
 * Build Formik/API role rows from the nested tree used in UserRoles.
 * @param {Array<Record<string, unknown>>} rolesTree
 * @returns {{ id?: unknown, name: string, active: boolean }[]}
 */
export function buildRoleFormPayloadFromTree(rolesTree) {
  const allRoles = [];
  (rolesTree || []).forEach((module) => {
    allRoles.push({
      id: module.id,
      name: module.name,
      active: Boolean(module.checked),
    });
    (module.actions || []).forEach((action) => {
      allRoles.push({
        id: action.id,
        name: action.name,
        active: Boolean(action.checked),
      });
    });
    (module.submodules || []).forEach((submodule) => {
      allRoles.push({
        id: submodule.id,
        name: submodule.name,
        active: Boolean(submodule.checked),
      });
      (submodule.actions || []).forEach((action) => {
        allRoles.push({
          id: action.id,
          name: action.name,
          active: Boolean(action.checked),
        });
      });
    });
  });
  return allRoles;
}
